import { render, staticRenderFns } from "./EmployeeWizardLinkModal.vue?vue&type=template&id=23f71b85&scoped=true&"
import script from "./EmployeeWizardLinkModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeWizardLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWizardLinkModal.vue?vue&type=style&index=0&id=23f71b85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f71b85",
  null
  
)

component.options.__file = "EmployeeWizardLinkModal.vue"
export default component.exports